import type { QueryParamsDto } from "@mimber/schema"

export const announcementsKeys = {
  findAll: (params?: QueryParamsDto) =>
    params
      ? (["announcements", "findAll", params] as const)
      : (["announcements", "findAll"] as const),
  findOne: (uuid: string) => ["announcements", "findOne", uuid] as const,
  getSchedule: (uuid: string) =>
    ["announcements", "getSchedule", uuid] as const,
} as const
